// React
import React from 'react';

// UI
import { Box } from '@mui/material';

// Panels
import PlayersPanel from '../players/playersPanel';
import TeamsPanel from '../teams/teamsPanel';

// Combined players + teams management UI for an event - shows both lists
// side by side. Used by the standalone full-screen dialog available from
// the event detail page (`eventPlayerSetupDialog.jsx`). The create/edit
// event wizard instead uses `ViewPlayersDialog` / `ViewTeamsDialog` so the
// lists aren't shown inline in the wizard step.
const PlayersTeamsManager = ({ canReplacePlayer = true, canPromoteReserve = false }) => {
  return (
    <Box display={'flex'} justifyContent={'space-evenly'} gap={2} flexWrap="wrap">
      <Box display={'flex'} flexDirection={'column'} flexGrow={1} minWidth={280} my={1}>
        <PlayersPanel canReplacePlayer={canReplacePlayer} />
      </Box>

      <Box display={'flex'} flexDirection={'column'} flexGrow={2} minWidth={320} my={1}>
        <TeamsPanel canPromoteReserve={canPromoteReserve} />
      </Box>
    </Box>
  );
};

export default PlayersTeamsManager;
